// 0024/0025: a single KPI tile (label + big value + optional hint). Presentational only.
// `tone` (green|amber|red|blue) drives the SEMANTIC color of the icon chip / value.
const KpiCard = ({ label, value, hint, icon, tone = "blue" }) => (
  <div className={`analyticsKpiCard analyticsKpiCard--${tone}`}>
    {icon && (
      <div className="analyticsKpiIcon">
        <i className={icon}></i>
      </div>
    )}
    <div className="analyticsKpiBody">
      <span className="analyticsKpiValue">{value}</span>
      <span className="analyticsKpiLabel">{label}</span>
      {hint && <span className="analyticsKpiHint">{hint}</span>}
    </div>
  </div>
);

export default KpiCard;
